<template>
	<b-card class="card-accent-success" header-tag="header" footer-tag="footer" no-body>
		<template v-slot:header>
			<b-button variant="primary" pressed><i class="fa-regular fa-notes-medical"></i> Current Decursus</b-button>
			<div class="card-header-actions">
<!-- 				<b-link :disabled="noRevisions" class="card-header-action btn-setting" v-b-tooltip.hover title="Browse Revisions" @click="decursusRevisions">
					<i class="fa-regular fa-clock-rotate-left"></i>
				</b-link> -->
				<b-link class="card-header-action btn-setting" @click="$emit('minimized', false)">
					<i class="fa-regular fa-columns"></i>
				</b-link>
			</div>
		</template>
		<validation-observer ref="observer" v-slot="{ passes }">
		<b-form @submit.prevent="passes(onFormSubmit)" novalidate>
			<b-tabs pills card content-class="border-left-0 border-right-0">
				<b-tab active>
			        <b-overlay no-center :show="confirm" no-wrap @shown="onShown">
			            <template #overlay>
							<div class="position-absolute" style="bottom: 25px; right: 25%; left: 20%;">
				                <div v-if="$store.getters['loading/isLoading']('current_decursus')" class="d-flex align-items-center">
				                    <strong>Updating...</strong>
				                    <b-spinner class="ml-auto"></b-spinner>
				                </div>
				                <div v-else ref="dialog" tabindex="-1" role="dialog" aria-modal="false" aria-labelledby="form-confirm-label">
				                    <p class="text-center">
				                        <i class="fa-solid fa-cloud-arrow-up font-sm text-success"></i> <strong class="text-success">UPDATE DECURSUS ? </strong>
				                    </p>
				                    <div class="text-center">
				                        <b-button variant="outline-danger" class="mr-3" @click="onCancel">Cancel</b-button>
				                        <b-button variant="outline-success" @click="onConfirmed">Confirm</b-button>
				                    </div>
				                </div>
        					</div>
			            </template>
			        </b-overlay>
					<template slot="title">
						<i class="fa-regular fa-notes-medical"></i> <small>{{ decursusDate }}</small>
					</template>
					<b-form-group :disabled="true"
						label="Decursus Date"
						:label-for="`date-decursus-${decursus?.id}`">
						<b-form-input :id="`date-decursus-${decursus?.id}`" readonly v-dateformat autocomplete="off" :value="decursus?.date" />
		        	</b-form-group>

					<validation-provider vid="subjective" v-slot="{ errors }">
			        	<speech-area v-shortcut-expand id="subjective" name="subjective" classes="squared-bottom" label="Subjective" :errors="errors[0]" v-model="form.subjective" placeholder="Add subjective..." :state="errors[0] ? false : (icpcSubjective ? true : null)" rows="4" @change="onUpdate">
			        		<validation-provider vid="icpc_subjective_id" v-slot="{ errors }">
							  <b-button
							    block
							    type="button"
							    class="squared-top"
							    :variant="errors[0] ? 'danger' : (icpcSubjective ? 'success' : 'primary')"
							    @click="icpcSubjective ? setICPC('icpc_subjective', null) : showICPCModal('icpc_subjective')"
							  >
							    <i :class="icpcSubjective ? 'fa-solid fa-ban' : 'fa-solid fa-seal'"></i>
							    {{ icpcSubjective ? icpcSubjective : 'ICPC Subjective' }}
							  </b-button>
							</validation-provider>
			        	</speech-area>
					</validation-provider>

					<validation-provider vid="objective" v-slot="{ errors }">
						<speech-area v-shortcut-expand id="objective" name="objective" label="Objective" :errors="errors[0]" v-model="form.objective" placeholder="Add objective..." :state="errors[0] ? false : null" rows="4" @change="onUpdate">
						</speech-area>
					</validation-provider>

					<validation-provider vid="evaluation" v-slot="{ errors }">
			        	<speech-area v-shortcut-expand id="evaluation" name="evaluation" classes="squared-bottom" label="Evaluation" :errors="errors[0]" v-model="form.evaluation" placeholder="Add evaluation..." :state="errors[0] ? false : (icpcEvaluation ? true : null)" rows="4" @change="onUpdate">
			        		<validation-provider vid="icpc_evaluation_id" v-slot="{ errors }">
							  <b-button
							    block
							    type="button"
							    class="squared-top"
							    :variant="errors[0] ? 'danger' : (icpcEvaluation ? 'success' : 'primary')"
							    @click="icpcEvaluation ? setICPC('icpc_evaluation', null) : showICPCModal('icpc_evaluation')"
							  >
							    <i :class="icpcEvaluation ? 'fa-solid fa-ban' : 'fa-solid fa-seal'"></i>
							    {{ icpcEvaluation ? icpcEvaluation : 'ICPC Evaluation' }}
							  </b-button>
							</validation-provider>
			        	</speech-area>
					</validation-provider>

	                <validation-provider vid="policy" v-slot="{ errors }">
						<b-form-group
							label="Policy"
							:invalid-feedback="errors[0]"
							:state="errors[0] ? false : null">
							<b-form-textarea 
								v-shortcut-expand
								id="policy" 
								name="policy" 
								v-model="form.policy" 
								placeholder="Add policy (type @pr for quick prescription)..." 
								rows="4" 
								@input="checkForPrescriptionTrigger" />
						</b-form-group>
					</validation-provider>
					<inline-prescription-entry
						ref="inlinePrescriptionEntry"
						:decursus-id="decursus?.id"
						@prescription-added="onInlinePrescriptionAdded"
						@cancel="cancelPrescriptionEntry(true)"
					/>
	                <validation-provider vid="comments" v-slot="{ errors }">
						<speech-area v-shortcut-expand
							id="comments" 
							name="comments" 
							label="Comments" 
							:errors="errors[0]" 
							v-model="form.comments" 
							placeholder="Add comments..." 
							:state="errors[0] ? false : null" 
							rows="4" 
							@change="onUpdate">
						</speech-area>
					</validation-provider>

	                <validation-provider vid="non_field_errors" v-slot="{ errors }">
				      <b-form-invalid-feedback :state="errors[0] ? false : null">
				      	<h6 class="d-block p-3 bg-danger ">{{ errors[0] }}</h6>
				      </b-form-invalid-feedback>
					</validation-provider>

				</b-tab>
			</b-tabs>
			<Referral :limit="5"/>
			<Episode  :limit="5"/>
			<Procedures />
			<b-card-footer class="border-0">
				<b-button :disabled="$store.getters['loading/isLoading']('decursus')" type="submit" variant="success">
					<i class="fa-regular fa-circle-dot"></i> Save Decursus
				</b-button>
		    </b-card-footer>
		</b-form>
		</validation-observer>
	</b-card>
</template>
<script>
import Vue from 'vue'
import FormExtension from "@/core/components/FormExtension"
import { mapGetters, mapState, mapActions } from 'vuex'

import ICPCModal from '../catalogue/ICPCModal'
import Episode from './Episode'
import Referral from './Referral'
import Procedures from './Procedures'
import InlinePrescriptionEntry from '../prescriptions/InlinePrescriptionEntry'

export default FormExtension.extend({
	name: 'decursus-current',
	components: {
		Episode,
			Referral,
			Procedures,
			InlinePrescriptionEntry
		},
		data() {
			return {
			form: new Form({
				subjective: "",
				icpc_subjective_id: null,
				objective: "",
				evaluation: "",
				icpc_evaluation_id: null,
				policy: "",
				comments: "",
				consistency_token: null
			}),

				confirm: false,
				showPrescriptionEntry: false,
				prescriptionTriggerRange: null
			}
		},
    computed: {
        ...mapGetters('decursus', ['getCurrentDecursus']),
        ...mapState('catalogue', {
            medication_repeat_dates: state => state.medication_repeat_dates,
        }),
        decursus() {
            return this.getCurrentDecursus()
        },
        decursusDate() {
        	return this.decursus ? this.toLocaleDate(this.decursus.date) : 'Loading...'
        },
        ...mapGetters('revisions', ['getRevisionsForDecursus']),
        revisions() {
            return this.getRevisionsForDecursus()
        },
        noRevisions() {
            return this.revisions.length < 2
        },
        icpcSubjective() {
        	return this.form.icpc_subjective_id ? `${this.form.icpc_subjective.code} ${this.form.icpc_subjective.name}` : null
        },
        icpcEvaluation() {
        	return this.form.icpc_evaluation_id ? `${this.form.icpc_evaluation.code} ${this.form.icpc_evaluation.name}` : null
        }
    },
    watch: {
    	icpcSubjective(val) {
    		if (this.form.dirty()) {
    			this.onUpdate(null)
    		}
    	},
    	icpcEvaluation(val) {
    		if (this.form.dirty()) {
    			this.onUpdate(null)
    		}
    	},
        decursus: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.form.withData(val)
                	this.getDecursusRevisions(val.id)
                }
            }
        },
        form: {
            deep: true,
            handler(val) {
                this.isDirty = this.form.dirty()

                if (this.isDirty) {
                    this.dirty()
                }else{
                    this.validated()
                }
            }
        }
    },
	methods: {
        ...mapActions('decursus', ['getCurrentDecursusByConsultationId', 'getCurrentDecursusForConsultation', 'updateDecursus']),
        ...mapActions('revisions', ['getDecursusRevisions', 'revertDecursusRevision']),
        ...mapActions('catalogue', ['getCatalogueItem']),
        ...mapActions('prescriptions', ['getPrescriptionsForCurrentPatient']),
        async loadForConsultation(consultation) {
        	if (this.decursus) {
        		await this.getCurrentDecursusForConsultation()

        	}else{
        		await this.getCurrentDecursusByConsultationId(consultation.id)
        	}
        },
        onFormSubmit() {
            this.confirm = true
        },
        onUpdate(value, notify=false) {
            this.updateDecursus({ notify: notify, data: this.form.data() }).then(() => {
            	if (notify) {
                	this.notify("Decursus updated", "Decursus was updated successfully")
            	}
                this.confirm = false
            })
            .catch(errors => {
                if (errors.response) {
                	if (notify) {
	            		this.notify("Error", "Something went wrong", 'danger')
	            	}
	                
	                this.$refs.observer?.setErrors(errors.response.data)
	                this.hasErrors = true
	                this.confirm = false
	            }
            })
        },
        onConfirmed() {
        	this.onUpdate(null, true)
        },
        onShown() {
            // Focus the dialog prompt
            this.$refs.dialog?.focus()
        },
        onCancel() {
            this.confirm = false
        },
        pasteIntoForm(field, value) {
        	this.form.populate({[field]: value})
        	this.notify("Field copied", `Field ${field} was updated`)
        },
		showICPCModal(field) {
			var ComponentClass = Vue.extend(ICPCModal)
			var instance = new ComponentClass({ parent: this })

			instance.$on("hidden", () => {
				instance.$destroy()
			})

			instance.$on("selected", (icpc) => {
				this.setICPC(field, icpc)
			})

			instance.$mount()
		},
		setICPC(field, icpc) {
			this.form.populate({[`${field}_id`]: icpc ? icpc.id : null})
			this.form.populate({[field]: icpc})

			this.$refs.observer?.reset()
		},
        decursusRevisions() {
            this.browseRevisions('Decursus', this.revisions)
        },
        async reverted(version) {
            await this.revertDecursusRevision({id: this.decursus.id, version: version})
        },
		findPrescriptionTrigger(text) {
			if (!text) {
				return null
			}

			const lines = text.split('\n')
			let cursor = 0
			let latest = null

			for (const line of lines) {
				const lineStart = cursor
				const lineEnd = lineStart + line.length
				const triggerMatch = line.match(/@pr\b/i)

				if (triggerMatch) {
					const triggerOffset = triggerMatch.index ?? -1
					const entryText = line.slice(triggerOffset + triggerMatch[0].length).trim()
					latest = {
						start: lineStart + triggerOffset,
						end: lineEnd,
						entryText
					}
				}

				cursor = lineEnd + 1
			}

			return latest
		},
			checkForPrescriptionTrigger(text) {
				const trigger = this.findPrescriptionTrigger(text)
				if (!trigger) {
					if (this.showPrescriptionEntry) {
						this.cancelPrescriptionEntry()
					}
					return
				}

				const isSameTrigger =
					this.prescriptionTriggerRange &&
					this.prescriptionTriggerRange.start === trigger.start &&
					this.prescriptionTriggerRange.end === trigger.end

				this.prescriptionTriggerRange = { start: trigger.start, end: trigger.end }

				if (this.showPrescriptionEntry && isSameTrigger) {
					return
				}

			if (!this.showPrescriptionEntry) {
				this.$nextTick(() => {
					this.$refs.inlinePrescriptionEntry?.activate(trigger.entryText || '')
				})
				this.showPrescriptionEntry = true
			}
		},
		async onInlinePrescriptionAdded(payload) {
			const parsedData = payload?.parsed || payload?.data || {}
			const isChronic = Boolean(payload?.isChronic)
			const readableText = this.generateReadablePrescription(parsedData, isChronic)
			const trigger = this.prescriptionTriggerRange

				if (trigger && trigger.start >= 0 && trigger.end >= trigger.start && trigger.end <= this.form.policy.length) {
					const beforeTrigger = this.form.policy.slice(0, trigger.start)
					const afterTrigger = this.form.policy.slice(trigger.end)
					this.form.policy = `${beforeTrigger}${readableText}${afterTrigger}`
				} else {
					this.form.policy = [this.form.policy, readableText].filter(Boolean).join('\n')
				}
				await this.updateDecursus({ notify: false, data: { policy: this.form.policy, consistency_token: this.form.consistency_token } })
				this.cancelPrescriptionEntry()
				await this.getPrescriptionsForCurrentPatient()
				EventBus.$emit('prescription-added', payload?.data || {})
			},
		generateReadablePrescription(data, isChronic) {
			let text = data.medication_name || ''
			
			if (data.strength) {
				text += ` ${data.strength}`
			}
			
			if (data.dosage_amount) {
				text += ` - ${data.dosage_amount}`
			}
			
			if (data.frequency_usage) {
				text += ` ${data.frequency_usage} times daily`
			}
			
			if (data.amount_of_time) {
				text += `, for ${data.amount_of_time} days`
			}
			
			text += isChronic ? ' (Chronic)' : ' (Regular)'
			
			return text
		},
			cancelPrescriptionEntry(fromInline = false) {
				this.showPrescriptionEntry = false
				this.prescriptionTriggerRange = null
				if (!fromInline) {
					this.$refs.inlinePrescriptionEntry?.cancel()
				}
			}
	},
	async mounted() {
		await this.getCatalogueItem('medication_repeat_dates')
		
		EventBus.$on('copied', payload => {
			this.pasteIntoForm(payload.field, payload.value)
		})
	},
	beforeDestroy() {
		 EventBus.$off("copied")
	}
})
</script>
